(function () {
  function normalizeReviewCount(text) {
    var match = String(text || "").match(/[\d,]+/);
    return match ? match[0].replace(/,/g, "") : "";
  }

  function formatReviewCount(text) {
    var count = normalizeReviewCount(text);
    if (!count) return "";
    return Number(count).toLocaleString("en-US");
  }

  function syncSortLabel(section) {
    var sort = section.querySelector("#junipReviewSort");
    var selectedValue = section.querySelector(".junip-selected-value");
    if (!sort || !selectedValue) return;

    var option = sort.options[sort.selectedIndex];
    if (option && option.textContent) {
      var optionLabel = option.textContent.trim();
      if (selectedValue.textContent !== optionLabel) {
        selectedValue.textContent = optionLabel;
      }
    }

    if (sort.dataset.omniSortEnhanced !== "true") {
      sort.addEventListener("change", function () {
        syncSortLabel(section);
      });
      sort.dataset.omniSortEnhanced = "true";
    }
  }

  function getReviewSections(scope) {
    if (scope && scope.matches && scope.matches(".junip-review-section-rendered")) {
      return [scope];
    }

    return Array.prototype.slice.call((scope || document).querySelectorAll(".junip-review-section-rendered"));
  }

  function makeVisible(element, displayValue) {
    element.style.setProperty("display", displayValue, "important");
    element.style.setProperty("visibility", "visible", "important");
    element.style.setProperty("opacity", "1", "important");
    element.style.setProperty("max-height", "none", "important");
    element.style.setProperty("overflow", "visible", "important");
  }

  function hideFilterToggle(toggle) {
    toggle.hidden = true;
    toggle.style.setProperty("display", "none", "important");
  }

  function ensureReviewCta(section) {
    var container = section.querySelector(".junip-product-review-container") || section;
    if (!container || container.querySelector(".review-cta")) return;

    var cta = document.createElement("div");
    cta.className = "review-cta";
    cta.innerHTML = [
      '<a class="review-cta__button" href="#featured-product">',
      '<span>TRY OMNI TODAY</span>',
      '<svg class="review-cta__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">',
      '<circle cx="12" cy="12" r="10" fill="#ffffff"/>',
      '<path d="M11 8l4 4-4 4M8 12h7" stroke="#1b4f97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
      '</a>',
      '<div class="review-cta__guarantee">',
      '<svg class="review-cta__guarantee-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">',
      '<path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>',
      '<path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
      '<p>30-Day Money-Back Guarantee</p>',
      '</div>'
    ].join("");

    container.appendChild(cta);
  }

  function ensureSortControls(section) {
    var filterToggle = section.querySelector(".junip-filters-toggle, [aria-controls='junip-filters-container'], button[aria-label*='filter' i]");
    var filtersContainer = section.querySelector(".junip-filters-container");

    if (filterToggle && !filtersContainer && filterToggle.dataset.omniOpened !== "true") {
      filterToggle.dataset.omniOpened = "true";
      filterToggle.hidden = false;
      filterToggle.style.setProperty("display", "block", "important");
      filterToggle.style.setProperty("position", "absolute", "important");
      filterToggle.style.setProperty("visibility", "hidden", "important");
      filterToggle.style.setProperty("opacity", "0", "important");
      filterToggle.style.setProperty("pointer-events", "none", "important");

      filterToggle.click();

      requestAnimationFrame(function () {
        enhanceJunipReviews(section);
      });
    }

    section.querySelectorAll(".junip-filters-toggle, [aria-controls='junip-filters-container'], button[aria-label*='filter' i]").forEach(hideFilterToggle);

    section.querySelectorAll(".junip-filters, .junip-filters-container").forEach(function (filters) {
      makeVisible(filters, filters.classList.contains("junip-filters-container") ? "flex" : "block");
    });
  }

  function resetReviewCardSizing(section) {
    section.querySelectorAll([
      ".junip-review-list-item-container",
      ".junip-review-list-item",
      ".junip-flex-wrapper",
      ".junip-review-content-container",
      ".junip-review-body"
    ].join(",")).forEach(function (element) {
      element.style.setProperty("height", "auto", "important");
      element.style.setProperty("min-height", "0", "important");
      element.style.setProperty("max-height", "none", "important");
    });

    section.querySelectorAll(".junip-recommendation-container, .junip-review-vote-container").forEach(function (element) {
      var actionRow = element.closest(".junip-d-flex");
      if (!actionRow) return;

      actionRow.style.setProperty("display", "none", "important");
      actionRow.style.setProperty("height", "0", "important");
      actionRow.style.setProperty("min-height", "0", "important");
      actionRow.style.setProperty("margin", "0", "important");
      actionRow.style.setProperty("padding", "0", "important");
    });
  }

  function normalizeVerifiedBuyerLabels(section) {
    section.querySelectorAll(".junip-verified").forEach(function (verifiedLabel) {
      if (!/^verified buyer$/i.test(verifiedLabel.textContent.trim())) return;

      var walker = document.createTreeWalker(verifiedLabel, NodeFilter.SHOW_TEXT);
      var node;

      while ((node = walker.nextNode())) {
        if (node.textContent.trim()) {
          node.textContent = node.textContent.replace(/verified buyer/i, "Verified Buyer");
        }
      }
    });
  }

  function normalizeReviewLoadMoreButton(section) {
    var container = section.querySelector(".junip-product-review-container") || section;
    var loadMoreButton = Array.prototype.slice.call(container.children).find(function (child) {
      return child.classList && child.classList.contains("junip-see-more");
    });

    if (loadMoreButton) {
      loadMoreButton.setAttribute("aria-label", "READ MORE");
      loadMoreButton.setAttribute("title", "READ MORE");
    }
  }

  function enhanceJunipReviews(root) {
    var scope = root || document;
    var sections = getReviewSections(scope);

    sections.forEach(function (section) {
      ensureSortControls(section);
      resetReviewCardSizing(section);
      normalizeVerifiedBuyerLabels(section);
      normalizeReviewLoadMoreButton(section);

      var average = section.querySelector(".junip-product-review-average");
      if (average) {
        var value = parseFloat(average.textContent || "");
        if (!Number.isNaN(value)) {
          var roundedValue = value.toFixed(1);
          if (average.textContent !== roundedValue) {
            average.textContent = roundedValue;
          }
        }
      }

      var originalCount = section.querySelector(".junip-product-review-count");
      var formattedCount = originalCount ? formatReviewCount(originalCount.textContent) : "";
      if (originalCount && formattedCount) {
        var summaryCountLabel = "Based on " + formattedCount + " Reviews";
        if (originalCount.textContent !== summaryCountLabel) {
          originalCount.textContent = summaryCountLabel;
        }
      }

      section.querySelectorAll(".junip-product-review-bar-wrapper").forEach(function (bar) {
        var label = bar.getAttribute("aria-label") || "";
        var countMatch = label.match(/,\s*([\d,]+)\s+reviews?/i);
        var count = countMatch ? countMatch[1] : "0";
        if (bar.dataset.omniCount !== count) {
          bar.dataset.omniCount = count;
        }
      });

      var summary = section.querySelector(".junip-product-review-summary-container");
      var filters = section.querySelector(".junip-filters");
      if (summary && filters) {
        var footer = summary.querySelector(".omni-junip-summary-footer");
        if (!footer) {
          footer = document.createElement("div");
          footer.className = "omni-junip-summary-footer";
          summary.appendChild(footer);
        }

        var total = footer.querySelector(".omni-junip-summary-total");
        if (!total) {
          total = document.createElement("div");
          total.className = "omni-junip-summary-total";
          footer.appendChild(total);
        }

        total.textContent = formattedCount ? formattedCount + " Reviews" : "";
        if (filters.parentElement !== footer) {
          footer.appendChild(filters);
        }
      }

      syncSortLabel(section);
      // Changed by Nika: replaced the custom TRY OMNI TODAY CTA with Junip's native load-more button.
      // ensureReviewCta(section);
      section.dataset.omniEnhanced = "true";
    });
  }

  var observerFrame = null;

  function scheduleEnhance() {
    if (observerFrame) return;

    observerFrame = requestAnimationFrame(function () {
      observerFrame = null;
      enhanceJunipReviews(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      enhanceJunipReviews(document);
    });
  } else {
    enhanceJunipReviews(document);
  }

  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
